<template>
  <div ref="sankeyChart" class="sankey-chart"></div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: "HerbSankeyChart",
  data() {
    return {
      myChart: {},
      option: {},
      sankeyData: {
        // 产业链节点数据
        nodes: [
          { name: '种植', value: 100 }, // 附加值基准值
          { name: '初加工', value: 150 }, // 附加值增加50%
          { name: '流通', value: 200 }, // 附加值增加33%
          { name: '制药企业', value: 350 }, // 附加值增加75%
          { name: '医疗机构', value: 400 }, // 附加值增加14%
          { name: '零售', value: 420 } // 附加值增加5%
        ],
        // 节点流向数据
        links: [
          { source: '种植', target: '初加工', value: 80 },
          { source: '初加工', target: '流通', value: 70 },
          { source: '流通', target: '制药企业', value: 60 },
          { source: '制药企业', target: '医疗机构', value: 40 },
          { source: '制药企业', target: '零售', value: 20 }
        ],
        // 各环节就业人数数据（模拟）
        employmentData: {
          '种植': 12500,
          '初加工': 5800,
          '流通': 3200,
          '制药企业': 1800,
          '医疗机构': 1200,
          '零售': 2500
        },
        // 节点颜色配置
        colors: ['#FFD700', '#FFA500', '#FF6347', '#4682B4', '#32CD32', '#9370DB']
      }
    };
  },
  methods: {
    initChart() {
      // 初始化图表
      this.myChart = echarts.init(this.$refs.sankeyChart);
      
      // 处理节点数据，添加就业人数信息到tooltip中
      const formattedNodes = this.sankeyData.nodes.map((node, index) => ({
        name: node.name,
        value: node.value,
        itemStyle: {
          color: this.sankeyData.colors[index]
        }
      }));
      
      // 设置桑基图配置项
      this.option = {
        title: {
          text: '中药材产业链价值流动图',
          left: 'center',
          textStyle: {
            color: '#fff',
            fontSize: 16
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: (params) => {
            if (params.type === 'node') {
              const employment = this.sankeyData.employmentData[params.name] || 0;
              const value = params.value;
              const prevNode = this.findPreviousNode(params.name);
              
              let tooltipContent = `${params.name}<br/>`;
              tooltipContent += `附加值: ${value} 元<br/>`;
              tooltipContent += `就业人数: ${employment.toLocaleString()} 人<br/>`;
              
              // 计算附加值增长率
              if (prevNode) {
                const growthRate = ((value - prevNode.value) / prevNode.value * 100).toFixed(1);
                tooltipContent += `环比增长: +${growthRate}%`;
              }
              
              return tooltipContent;
            } else if (params.type === 'edge') {
              return `${params.data.source} → ${params.data.target}<br/>价值流: ${params.data.value} 元`;
            }
            return params.name;
          },
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          borderColor: '#666',
          textStyle: {
            color: '#fff'
          }
        },
        legend: {
          top: 30,
          data: ['产业链环节'],
          textStyle: {
            color: '#fff'
          }
        },
        series: [
          {
            type: 'sankey',
            left: 50,
            right: 50,
            data: formattedNodes,
            links: this.sankeyData.links,
            lineStyle: {
              color: 'gradient',
              curveness: 0.5
            },
            itemStyle: {
              borderWidth: 1,
              borderColor: '#aaa'
            },
            label: {
              color: '#fff',
              fontSize: 12
            },
            emphasis: {
              focus: 'adjacency',
              itemStyle: {
                shadowBlur: 10,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };
      
      // 渲染图表
      this.myChart.setOption(this.option);
    },
    
    // 查找前一个节点，用于计算环比增长率
    findPreviousNode(nodeName) {
      const nodeIndex = this.sankeyData.nodes.findIndex(node => node.name === nodeName);
      if (nodeIndex > 0) {
        return this.sankeyData.nodes[nodeIndex - 1];
      }
      return null;
    },
    
    // 处理窗口大小变化
    handleResize() {
      if (this.myChart && !this.myChart.isDisposed()) {
        this.myChart.resize();
      }
    }
  },
  mounted() {
    // 初始化图表
    this.initChart();
    
    // 添加窗口大小变化监听
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    // 移除窗口大小变化监听
    window.removeEventListener('resize', this.handleResize);
    
    // 销毁图表实例
    if (this.myChart && !this.myChart.isDisposed()) {
      this.myChart.dispose();
    }
  }
};
</script>

<style lang="less" scoped>
.sankey-chart {
  width: 100%;
  height: 100%;
  min-height: 400px;
}
</style>